import React, { useEffect, useState } from 'react';
import { setCookie, getCookie } from 'src/utils/useCookies';
import { Layout, LayoutCommunity } from '../';

export const Experiment = () => {
  const [cookieValue, setCookieValue] = useState('');

  const getRandom = () => {
    const r = Math.random() * 100;
    if (r <= 50) return 'A';
    return 'B';
  };

  useEffect(() => {
    const currentCookie = getCookie('lear-SCH5254');

    if (currentCookie === undefined) {
      const newCookie = getRandom();
      setCookie('lear-SCH5254', newCookie, 600000);
      setCookieValue(newCookie);
    } else {
      setCookieValue(currentCookie);
    }
  }, []);

  if (cookieValue === 'A') {
    return <Layout />;
  }

  if (cookieValue === 'B') {
    return <LayoutCommunity />;
  }
};
